module.exports = __webpack_public_path__ + "img/img-111.a63dedbb.png";